import { Button, ButtonGroup, SxProps, Theme } from "@fxc/ui-kit";
import { useFormContext } from "react-hook-form";

export function FormButtons({ sx }: { sx?: SxProps<Theme> }) {
  const form = useFormContext();

  return (
    <ButtonGroup
      disabled={
        !form.formState.isDirty ||
        form.formState.isLoading ||
        form.formState.isSubmitting
      }
      sx={sx}
    >
      <Button type={"submit"} data-qa={"save-button"}>
        Save
      </Button>
      <Button
        type="reset"
        onClick={() => form.reset()}
        data-qa={"reset-button"}
      >
        Reset
      </Button>
    </ButtonGroup>
  );
}
